import PropTypes from 'prop-types';
import React from 'react';
import isEqual from 'is-equal';

import { Row, Col } from "react-bootstrap";
import styles from "./styles.module.scss";
import cx from 'classnames';
import buildUrl from "build-url-ts";
import EventService from 'src/utils/event.service.jsx';
import ChatUserRow from '../chatUserRow/view.jsx';
import ChatContainer from '../chat/index.jsx';
import SwitchButton from "src/components/switchButton";
import PlaceholderEmptyMessage from "src/components/placeholderEmptyMessage";
import RolodexEmptyMessageSvgIcon from "src/legacy/images/homeEmptyMessage.svg";
import InfiniteScroll from 'react-infinite-scroller';
import ContactDetailsSlideview from 'src/legacy/components/Contacts/ContactDetails/ContactDetailsSlideview.jsx'
import Slider from 'src/components/slider'

import _ from 'lodash';
import LivePage from '../liveView';
import SlidePaneView from 'src/legacy/components/SlidePaneView';
import Button from 'src/components/button';
import userRoleService from 'src/utils/userRoles.service.js';
import { localizedStrings } from 'src/localization/index.jsx';

class ChatUsersListView extends React.Component {
  
  static contextTypes = {
    store: PropTypes.object.isRequired
  }
  
  constructor(props) {
    super(props);

    this.state = {
      chatUsers: _.get(props, 'chatUsers'),
      query: "",
      showChat: false,
      liveView: false,
      channelNames: _.get(this.props.chatUser, 'uuid') || "",
      global: _.get(this.props.location, 'query.global') === "true",
      filter: _.get(this.props.location, 'query.filter') || "all",
      selectedContact: null,
      showBlockConfirmation: false,
      blocked: false
    }

    this._handleChatUserChange = this._handleChatUserChange.bind(this);
    this._handleBlockRecipientClick = this._handleBlockRecipientClick.bind(this);
    this._handleCancelClick = this._handleCancelClick.bind(this);
    this.handleGlobalRecipientToggle = this.handleGlobalRecipientToggle.bind(this);
    this.loadMoreChatUsers = this.loadMoreChatUsers.bind(this);
    this.toggleLiveView = this.toggleLiveView.bind(this);
    this.showBlockConfirmationView = this.showBlockConfirmationView.bind(this);

    this.localizedEngage = localizedStrings.pages.engage;
    this.localizedCommons = localizedStrings.commons;
  }

  componentDidMount(){
    this.props.fetchChatUser(this.props.params.id);
    this.setState({
      global: _.get(this.props.location, 'query.global') === "true",
      filter: _.get(this.props.location, 'query.filter') || "all"
    });
    this.props.fetchChatUsers(0, this.state.filter, this.state.global);
  }

  componentWillUnmount(){
    this.props.invalidateSmallTalkSession(this.props.chatUser);
  }

  componentWillReceiveProps(nextProps) {

    if (!isEqual(this.props.engageEnabled, nextProps.engageEnabled)){
      this.setState({
        showChat: true
      })
    }

    if (!isEqual(this.props.params.id, nextProps.params.id)) {
      this.props.fetchChatUser(nextProps.params.id);
      this.setState({
        showChat: true
      })
    }

    if (!isEqual(this.props.chatUsers, nextProps.chatUsers)) {
      this.setState({
        chatUsers: _.get(nextProps, 'chatUsers')
      });
    }
    
    if (!isEqual(this.props.chatUser, nextProps.chatUser)){
      this.setState({
        channelNames: nextProps.chatUser.uuid,
        showChat: true,
        global: _.get(nextProps.location, 'query.global') === "true",
        filter: _.get(nextProps.location, 'query.filter') || "all"
      });
      
      if (!isEqual(this.props.chatUser && this.props.chatUser.chatUserId, nextProps.chatUser.chatUserId)){
        this.props.initiateSmallTalkSession(nextProps.chatUser);
      }
    }

    if (!nextProps.params.id) {
      if (nextProps.chatUsers && nextProps.chatUsers.length > 0) {
        var chatUser = nextProps.chatUsers[0];
        this.props.navigate(`/engage/${chatUser.id}`);
      }
    }

    if (!_.isEqual(_.get(this.props.location, 'query.global'), _.get(nextProps.location, 'query.global')) ||
      !_.isEqual(_.get(this.props.location, 'query.filter'), _.get(nextProps.location, 'query.filter'))) {
      this.handleUrlChange(nextProps);
    }
  }

  _handleChatUserChange(chatUserId){
    var url = buildUrl(`/engage/${chatUserId}`, {
      queryParams: {
        filter: this.state.filter,
        global: this.state.global
      }
    });


    this.props.navigate(url);
  }

  _handleBlockRecipientClick(){
    this.props.blockChatUser(this.props.chatUser.chatUserId, this.state.blocked).then((response) => {
        if(response.type == "LEGACY_BLOCK_CHAT_USER_SUCCEEDED") {
          this._handleCancelClick();
        }
      });
  }
  
  _handleCancelClick(){
    this.setState({
      showBlockConfirmation: false
    })
  }

  handleGlobalRecipientToggle() {
    this.setState(
      (prevState) => ({ global: !prevState.global }),
      () => {
        this.props.trackAdoptionMetricsForAllRecipientsToggledEvent();
        this.updateUrl("all", this.state.global);
      }
    );
  }

  updateUrl(filter, global) {
    const url = buildUrl(this.props.location.pathname, {
      queryParams: {
        filter: filter,
        global: global
      }
    });

    this.props.navigate(url, { replace: true }); 
  }

  handleFilter(filter) {
    const filterName = EventService.getLegendName(filter);
    this.props.trackAdoptionMetricsForViewerFilterAppliedEvent(filterName);
    this.updateUrl(filter, this.state.global);
  }

  handleUrlChange(props) {
    const global = _.get(props.location, 'query.global') === "true";
    const filter = _.get(props.location, 'query.filter') || "all";

    this.setState({
      filter: filter,
      global: global
    }, () => {
      this.props.fetchChatUsers(0, filter, global);
    });
  }

  renderEmptyMessage(){
    return(
      <div className={styles.emptyMessage}>
        {this.props.loading ? `${this.localizedCommons.loading.loading}...`:this.localizedEngage.chat_view.options.empty_message.no_activity}
      </div>
    )
  }

  renderChatEmptyMessage() {
    var message = this.localizedEngage.empty_message.no_recipients

    if (this.state.filter == "unread") {
      message = this.localizedEngage.empty_message.unread_chats
    } else if (this.state.filter == "live") {
      message = this.localizedEngage.empty_message.no_live_users
    }

    return (
      <PlaceholderEmptyMessage
        title={this.localizedEngage.empty_message.title}
        message={message}
        image={RolodexEmptyMessageSvgIcon}
        className={styles.chatEmptyMessage}
        visible={true}
      />
    );
  }

  renderBlockConfirmation() {
    var localizedBlock = this.localizedEngage.individual_chat.actions.slider;
    var localizedBlockText = this.localizedEngage.individual_chat.actions.slider.block_view;
    return (
    <Slider.Dialog width={"380"} show={this.state.showBlockConfirmation} onClose={() => this.setState({ showBlockConfirmation: false })}>
      <div className={styles.blockRecipientSlider}>
        <p className={styles.blockRecipientHeading}>
          {localizedStrings.formatString(localizedBlock.block_view.title, {
            status: !this.state.blocked ? localizedBlock.block_view.unblock : localizedBlock.block_view.block
            })}
        </p>
        <p className={styles.blockRecipientSubText}>
          {!this.state.blocked ? localizedBlockText.unblock_sub_text : localizedBlockText.block_sub_text}
        </p>
      </div>
      <Button className={styles.buttonTray}>
        <Button
          variant="primary"
          text={this.props.blocking ? "Confirming..." : "Confirm"}
          disabled={this.props.blocking}
          onClick={this._handleBlockRecipientClick}
        />
        <Button
          variant="secondary"
          text="Cancel"
          disabled={this.props.blocking}
          onClick={() => this.setState({ showBlockConfirmation: false })}
        />
      </Button>
    </Slider.Dialog>
    );
  }

  loadMoreChatUsers() {
    let totalPages = this.props.totalPages;
    let currentPage = this.props.currentPage;
    let nextPage = currentPage + 1;

    if (this.props.loading || nextPage > totalPages) {
      return;
    }

    this.props.fetchChatUsers(nextPage, "", this.state.global);
  }

  toggleLiveView(){
    this.setState({
      liveView: !this.state.liveView
    })
  }

  showBlockConfirmationView(blocked) {
    this.setState({
      showBlockConfirmation: true,
      blocked: blocked
    })
  }

  renderChatUsers() {
    var children = Array();

    this.state.chatUsers && this.state.chatUsers.forEach(chatUser => {
      children.push(
        <div className={styles.chatUsers}>
          <ChatUserRow key={chatUser.id}
            chatUser={chatUser}
            icon={chatUser.contactDTO ? chatUser.contactDTO.icon : null}
            activeChatUser={this._handleChatUserChange}
            filter={this.state.filter}
            global={this.state.global}
            trackAdoptionMetricsForRecipientSelectedEvent={this.props.trackAdoptionMetricsForRecipientSelectedEvent}
          />
        </div>
      )
    });

    var url = buildUrl('/engage', {
      queryParams: {
        filter: this.state.filter,
        global: this.state.global
      }
    });

    return (
      <div className={styles.chatUsersListSection}>
        <Row className={styles.header}>
          <Col sm={12} className={styles.column}>
            <h1 className={styles.pageTitle}>
            <div
            className={styles.backArrow}
            onClick={() => this.props.navigate(url, { replace: true })}
            >
                <i className="fa fa-angle-left" aria-hidden="true"></i>{this.localizedCommons.actions.back}
              </div>
              <div className={styles.pageTitleContent}>
                <span>
                {this.localizedEngage.chat_view.title}
                </span>
                <span className={styles.count}>
                  ({this.props.totalRecords})
                </span>
              </div>
            </h1>
            <p className={styles.subTitle}>
            {this.localizedEngage.chat_view.sub_text}
            </p>
          </Col>
          {userRoleService.canAccessGlobalRecipients() &&
            <Col sm={12} className={styles.toggleSection}>
              <SwitchButton
              id="global-recipient-toggle"
              className={styles.switchButton}
              handleCheck={this.handleGlobalRecipientToggle}
              checked={this.state.global}
            />
              <span className={styles.toggleSectionHeading}>
              {localizedStrings.formatString(this.localizedEngage.chat_view.show_all_recipients,{accountName:this.props.account.name})}
              </span>
            </Col>
          }
          <Col sm={12} className={styles.filters}>
            <p
              className={cx({
                [styles.active]: this.state.filter == "all"
              })}
              onClick={() => this.handleFilter("all")}>
              {this.state.global ? this.localizedCommons.recipients : this.localizedEngage.viewers.options.my_recipients}
              {this.state.filter == "all" && !this.props.loading && ` (${this.props.totalRecords})`}
            </p>
            <p
              className={cx({
                [styles.active]: this.state.filter == "live"
              })}
              onClick={() => this.handleFilter("live")}>
              {this.localizedEngage.chat_view.options.live_users}
              {this.state.filter == "live" && !this.props.loading && ` (${this.props.totalRecords})`}
            </p>
            <p
              className={cx({
                [styles.active]: this.state.filter == "unread"
              })}
              onClick={() => this.handleFilter("unread")}>
              {this.localizedEngage.chat_view.options.unread_chats}
              {this.state.filter == "unread" && !this.props.loading && ` (${this.props.totalRecords})`}
            </p>
          </Col>
        </Row>
        <div className={styles.list}>
          <div className={styles.chatUsersList} ref={(element) => {
            this.scrollContainer = element;
          }}>
            {this.state.chatUsers && this.state.chatUsers.length > 0 &&
              <InfiniteScroll
                pageStart={0}
                initialLoad={false}
                hasMore={this.props.currentPage < this.props.totalPages}
                loadMore={this.loadMoreChatUsers}
                useWindow={false}
                threshold={200}
              >
                {children}
              </InfiniteScroll>
            }
            {this.state.chatUsers && this.state.chatUsers.length == 0 && this.renderEmptyMessage()}
          </div>
        </div>
      </div>
    );
  }

  render() {

    return(
      <Row className={styles.content}>
        {!this.state.liveView && 
          <Col md={4} className={cx(styles.leftView)}>
            {this.renderChatUsers()}
            <div className={styles.verticalBorder}></div>
          </Col>
        }

        <Col
          md={8}
          className={cx(styles.rightView)}
        >
          {this.state.chatUsers && this.state.chatUsers.length > 0 && 
            this.state.showChat && this.state.channelNames &&
            <ChatContainer
              showContactSlideView={(contact) => {
                this.setState({
                showContactSlideView: true,
                selectedContact: contact
                })}
              }
              toggleLiveView={this.toggleLiveView}
              id={this.props.params.id}
              channelNames={this.state.channelNames}
              showBlockConfirmationView={this.showBlockConfirmationView}/>
          }
          {this.state.chatUsers && this.state.chatUsers.length == 0 && 
            !this.props.loading &&
            this.renderChatEmptyMessage()
          }
          
        </Col>
        {this.state.liveView &&
          <Col md={4} className={cx(styles.leftView)}>
            <LivePage 
            chatUserId={this.props.params.id}
            toggleLiveView={this.toggleLiveView}/>
          </Col>
        }
        {this.state.showContactSlideView &&
          <ContactDetailsSlideview onClose={() => this.setState({
            showContactSlideView: false
          })} 
          selectedContact={this.state.selectedContact} />
        }

        {this.renderBlockConfirmation()}
      </Row>
    )
  }
}

ChatUsersListView.contextTypes = {
  store: PropTypes.object
}

export default ChatUsersListView;